export enum ExamInstanceEvaluationStatusEnum {
  Draft = 'draft',
  Processing = 'processing',
  Completed = 'completed',
  NeedsReview = 'needs_review',
}

export const ExamInstanceEvaluationStatusEnumLabels: Record<ExamInstanceEvaluationStatusEnum, string> = {
  [ExamInstanceEvaluationStatusEnum.Draft]: 'Borrador',
  [ExamInstanceEvaluationStatusEnum.Processing]: 'Procesando',
  [ExamInstanceEvaluationStatusEnum.Completed]: 'Completada',
  [ExamInstanceEvaluationStatusEnum.NeedsReview]: 'Revisión pendiente',
};
